import FieldsetFooter from './fieldset-footer'

import FieldsetFooterStatus from './fieldset-footer-status'
import FieldsetFooterActions from './fieldset-footer-actions'

FieldsetFooter.Actions = FieldsetFooterActions
FieldsetFooter.Status = FieldsetFooterStatus

export default FieldsetFooter
